import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { take } from 'rxjs/operators';
import { MatterDispatch } from '@state/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { BlankTitleInsurance } from '../../../chicago/chicago.component';
import { TitlePlusStatus } from '@models/title-insurance';
import {
	TitlePlusCancelModalComponent,
	TitlePlusCancelModalData,
} from '../title-plus-cancel-modal/title-plus-cancel-modal.component';
import { TitlePlusModalComponent } from '../title-plus-modal/title-plus-modal.component';
import { TestHooks } from './title-plus-footer.hooks';

@Component({
	selector: 'app-title-plus-footer',
	templateUrl: './title-plus-footer.component.html',
	styleUrls: ['./title-plus-footer.component.scss'],
	standalone: false,
})
export class TitlePLUSFooterComponent {
	testHooks = TestHooks;
	public blankTitleInsurance = BlankTitleInsurance;
	public ICON = ICON;
	@Input() status: TitlePlusStatus;
	@Input() allowCancel = true;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private dialog: MatDialog,
		private matterDispatch: MatterDispatch,
	) {}

	cancel(): void {
		const data: TitlePlusCancelModalData = {
			status: this.status,
		};

		const modalRef = this.dialog.open(TitlePlusCancelModalComponent, {
			data,
			maxWidth: '450px',
			width: '90%',
		});

		modalRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((value) => {
				if (value) {
					if (!this.status || this.status === TitlePlusStatus.NOT_SUBMITTED) {
						this.matterDispatch.SetTitleInsurance(
							this.matterId,
							this.blankTitleInsurance,
						);
					} else {
						this.dialog.open(TitlePlusModalComponent);
					}
				}
			});
	}
}
